import { render, staticRenderFns } from "./CustomColorInput.vue?vue&type=template&id=2ef09894&scoped=true"
import script from "./CustomColorInput.vue?vue&type=script&lang=js"
export * from "./CustomColorInput.vue?vue&type=script&lang=js"
import style0 from "./CustomColorInput.vue?vue&type=style&index=0&id=2ef09894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef09894",
  null
  
)

export default component.exports